import { hexToRGB } from "@shared/utils/misc";
import { css } from "styled-components";

export const CODE_BOX_HEIGHT = 54;

export const onboardingStyles = {
  primaryTitle: css<{ $isMobile?: boolean }>`
    font-size: ${(p) =>
      p.$isMobile ? "22px" : p.theme.typography.fontSizes.XXL};
    font-weight: ${(p) => p.theme.typography.fontWeights.BOLD};
    margin-bottom: 32px;
    text-align: center;
  `,
  referralCodeMessageWrapper: css<{ $isMobile: boolean }>`
    flex-direction: column;
    background: ${(p) => hexToRGB(p.theme.colors.lightGreen, 0.2)};
    padding: ${(p) => (p.$isMobile ? "8px 4px" : "8px 16px")};
    margin-bottom: 24px;
    text-align: center;
  `,
  verificationCodeBox: css<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 0;
    height: ${CODE_BOX_HEIGHT}px;
    flex: 1;
    border-radius: 6px;
    ${(p) =>
      p.$isSelected
        ? `
    border-color: ${p.theme.colors.primaryBlue};
    border-width: 1.5px;
  `
        : `
    border-color: ${p.theme.colors.mediumBorderGrey};
    border-width: 1px;
  `};
  `,
};
